var checkLazy = function () {
  $(".lazy").each(function () {
    let $self = $(this);
    let delay = $self.data("delay") || 0;

    $self.removeClass("lazy");

    if (delay) {
      setTimeout(function () {
        setLazy($self);
      }, delay);
    } else {
      setLazy($self);
    }
  });
};

var setLazy = function (element) {
  $(element).lazy({
    effect: "fadeIn",
    // threshold: 1920,
    visibleOnly: true,
    beforeLoad: function (element) {
      element.addClass("lazy-loading");
    },
    afterLoad: function (element) {
      // replaceSvg();

      element.removeClass("lazy-loading");

      if (element.find("lazy")) {
        checkLazy();
      }
    },
  });
};
